import { gql } from '@apollo/client'

export const GET_INTERNAL_DOMAINS = gql`
  query {
    getInternalDomains
  }
`
